import React, { useState } from "react";
import { Mail, Check } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export const NewsletterSignup = ({ variant = "footer" }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
      toast.success("You're subscribed! 🎉");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Subscription failed");
    }
  };

  if (variant === "hero") {
    return (
      <section className="max-w-7xl mx-auto px-4 sm:px-6 mt-20" data-testid="newsletter-hero">
        <div className="bg-[#0047AB] text-white p-8 md:p-14 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-1 text-center md:text-left">
            <span className="label-caps text-white/70">Stay in the loop</span>
            <h2 className="font-heading text-2xl md:text-4xl tracking-tight font-medium mt-1 mb-2">Best sellers, new brands & exclusive offers</h2>
            <p className="text-white/80">Join our newsletter for weekly best-sellers, popular items, trending brands and real customer picks — straight to your inbox.</p>
          </div>
          {done ? (
            <div className="flex items-center gap-2 bg-white/15 px-6 py-4" data-testid="newsletter-done"><Check className="w-5 h-5" /> Subscribed</div>
          ) : (
            <form onSubmit={submit} className="flex w-full md:w-auto">
              <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="you@email.com"
                className="px-4 py-3.5 text-black outline-none w-full md:w-72" data-testid="newsletter-email-hero" />
              <button type="submit" className="bg-[#0A0A0A] text-white px-6 py-3.5 font-medium hover:bg-black transition-colors whitespace-nowrap" data-testid="newsletter-submit-hero">Sign up</button>
            </form>
          )}
        </div>
      </section>
    );
  }

  return (
    <div data-testid="newsletter-footer">
      <h4 className="label-caps text-neutral-500 mb-4">Newsletter</h4>
      {done ? (
        <p className="text-sm text-[#5fd39e] flex items-center gap-1"><Check className="w-4 h-4" /> You're subscribed</p>
      ) : (
        <form onSubmit={submit} className="flex border border-white/20">
          <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="Email address"
            className="bg-transparent px-3 py-2 text-sm outline-none flex-1 text-white placeholder:text-neutral-500" data-testid="newsletter-email-footer" />
          <button type="submit" className="px-3 bg-[#0047AB] hover:bg-[#003380] transition-colors" data-testid="newsletter-submit-footer"><Mail className="w-4 h-4" /></button>
        </form>
      )}
    </div>
  );
};
